module.exports = [{
      plugin: require('/tmp/5fe0ea98/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/5fe0ea98/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
